import { render, staticRenderFns } from "./CALCULADORA_TC.vue?vue&type=template&id=209d5473&scoped=true&"
import script from "./CALCULADORA_TC.vue?vue&type=script&lang=js&"
export * from "./CALCULADORA_TC.vue?vue&type=script&lang=js&"
import style0 from "./CALCULADORA_TC.vue?vue&type=style&index=0&id=209d5473&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209d5473",
  null
  
)

export default component.exports